(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvErrorLayer', function() {
    return {
      restrict: 'E',
      scope: { vvError: '=' },
      templateUrl: '/m/errorLayer.html?_hv=d704a67',
      controller: function($scope) {
        $scope.showLayer = ($scope.vvError != null);
        $scope.close = function() {
          $scope.showLayer = false;
        };
        $scope.doAction = function() {
          $scope.vvError.action();
        };
      }
    };
  });
})(window, window.angular);
